export enum APIErrorCode {
  DEFAULT = "DEFAULT",
  OUT_OF_STOCK_ONLINE = "OUT_OF_STOCK_ONLINE",
  CHILD_ITEM_INVALID = "CHILD_ITEM_INVALID",
  PRODUCT_NOT_FOUND = "PRODUCT_NOT_FOUND",
  STOCK_EXCEEDED_WARNING = "STOCK_EXCEEDED_WARNING",
  STOCK_EXCEEDED_ERROR = "STOCK_EXCEEDED_ERROR",
  MAX_PURCHASE_QUANTITY_EXCEEDED_WARNING = "MAX_PURCHASE_QUANTITY_EXCEEDED_WARNING",
  MAX_PURCHASE_QUANTITY_EXCEEDED_ERROR = "MAX_PURCHASE_QUANTITY_EXCEEDED_ERROR",
  ITEM_NO_LONGER_AVAILABLE = "ITEM_NO_LONGER_AVAILABLE",
  ITEM_QUANTITY_NO_LONGER_AVAILABLE = "ITEM_QUANTITY_NO_LONGER_AVAILABLE",
  BASKET_ITEM_ID_NOT_FOUND = "BASKET_ITEM_ID_NOT_FOUND",
  CHILD_QUANTITY_INVALID = "CHILD_QUANTITY_INVALID",
  QUANTITY_MIN_INVALID = "QUANTITY_MIN_INVALID",
  SAVE_FOR_LATER_DEFAULT = "SAVE_FOR_LATER_DEFAULT",
  INVALID_PRODUCT_TYPE = "INVALID_PRODUCT_TYPE",
  BAD_REQUEST = "BAD_REQUEST",
  BASKET_NOT_FOUND = "BASKET_NOT_FOUND",
  CONCURRENT_UPDATE = "CONCURRENT_UPDATE",
  ORDERING_IN_PROGRESS_RETRY = "ORDERING_IN_PROGRESS_RETRY",
  BASKET_IN_STASHED_STATE = "BASKET_IN_STASHED_STATE",
  BUNDLE_COMPONENT_NOT_VALID = "BUNDLE_COMPONENT_NOT_VALID",
  BUNDLE_COMPONENT_VARIANT_ID_REQUIRED = "BUNDLE_COMPONENT_VARIANT_ID_REQUIRED",
  WINDOW_DRESSING_NOT_IMPLEMENTED = "WINDOW_DRESSING_NOT_IMPLEMENTED",
  MISMATCHED_CONFIGURATION_TYPE = "MISMATCHED_CONFIGURATION_TYPE",
  INVALID_CONFIGURATION_DATATYPE = "INVALID_CONFIGURATION_DATATYPE",
  MISSING_CONFIGURATION = "MISSING_CONFIGURATION",
  CONFIGURATION_REJECTED = "CONFIGURATION_REJECTED",
  CONNECTION_ERROR = "CONNECTION_ERROR",
  BASKET_CONFLICT_RETRY = "BASKET_CONFLICT_RETRY",
  PARENT_LINE_ITEM_ID_NOT_FOUND = "PARENT_LINE_ITEM_ID_NOT_FOUND",
  LINE_ITEMS_EXCEEDS_MAX = "LINE_ITEMS_EXCEEDS_MAX",
  PRODUCT_NOT_AVAILABLE_FOR_ORDERING = "PRODUCT_NOT_AVAILABLE_FOR_ORDERING",
  BASKET_NOT_CREATED = "BASKET_NOT_CREATED",
  QUOTE_EXPIRED = "QUOTE_EXPIRED",
  QUOTE_WITHOUT_PURCHASE = "QUOTE_WITHOUT_PURCHASE",
  QUOTE_WITH_ERROR_ITEM = "QUOTE_WITH_ERROR_ITEM",
  MULTIPLE_QUOTES = "MULTIPLE_QUOTES",
  QUOTE_SERVICE_ERROR = "QUOTE_SERVICE_ERROR",
  TRADEIN_QUOTE_ALREADY_PRESENT = "TRADEIN_QUOTE_ALREADY_PRESENT",
  STOCK_SOURCE_MISMATCH = "STOCK_SOURCE_MISMATCH",
  BOT_IDENTIFIED = "BOT_IDENTIFIED",
  OFFER_CODE = "OFFER_CODE",
  OFFER_CODE_NOT_APPLIED = "OFFER_CODE_NOT_APPLIED",
  OFFER_NOT_APPLIED_MISSING_SHIPPING_INFO = "OFFER_NOT_APPLIED_MISSING_SHIPPING_INFO",
  OFFER_PARTIALLY_APPLIED_MISSING_SHIPPING_INFO = "OFFER_PARTIALLY_APPLIED_MISSING_SHIPPING_INFO",
  UNKNOWN_OFFER_ERROR = "UNKNOWN_OFFER_ERROR",
  OFFER_CODE_ORDER_CAPTURE_NOT_AVAILABLE = "OFFER_CODE_ORDER_CAPTURE_NOT_AVAILABLE",
}

export enum Currency {
  GBP = "GBP",
  EUR = "EUR",
  USD = "USD",
  AUD = "AUD",
  CAD = "CAD",
  DKK = "DKK",
  HKD = "HKD",
  NZD = "NZD",
  SGD = "SGD",
  CHF = "CHF",
  ZAR = "ZAR",
  NOK = "NOK",
  SEK = "SEK",
}

export enum LoyaltyVoucherSelected {
  LOADED = "LOADED",
  UNLOADED = "UNLOADED",
}

export interface APIError {
  message?: string;
  originSystem?: Service;
  id?: string;
  status?: string;
  responseCode?: number;
  code?: APIErrorCode;
}

export interface BasketDiscount {
  name: string;
  amount: number;
  affectsFulfilmentPrice: boolean;
}

export interface BasketItem {
  id: string;
  price: number;
  totalPrice: number;
  productCode: string;
  productId?: string;
  quantity: number;
  skuId: string;
  type: string;
  name: string;
  message: string;
  promotionalMessages: string[];
  imageUrl: string;
  pdpUrl: string;
  deliveryOptions: BasketItemDeliveryOption[];
  stockLevel: number;
  availabilityStatus: string;
  availability?: BasketItemAvailability;
  isUnlimitedStock: string;
  uom: string;
  childItems: BasketItemChildItem[];
  information: BasketItemInformation[];
  optionalServices: OptionalService[];
  maxPurchaseQuantity?: number;
  variantId: string;
  originalPrice?: number;
  brand?: Brand;
  creditOfferingIds?: string[];
  creditEligibility?: string;
  isAnyAlternativeAvailable: boolean;
  variantTraits?: BasketItemTraits;
  energy?: BasketItemEnergy;
  detailedPromotionalMessages: BasketItemPromotionalMessage[];
  variantPrice?: BasketItemVariantPrice;
  sellingRestrictions?: BasketItemSellingRestrictions;
  emailMeWhenAvailable: boolean;
  discountValue?: number;
  discounts: BasketItemDiscount[];
  creditEligibilityStatus: string[];
}

export interface BasketItemDiscount {
  name: string;
  amount: number;
}

export interface BasketRequestResponse {
  errors: APIError[];
  basket?: BasketUIBasket;
  deliveryOptions?: DeliveryOption[];
  qualifications?: string[];
  saveForLater?: BasketSaveForLater;
  deliveryQualifications?: DeliveryQualificationsResponse;
  commerceItems?: BasketItem[];
}

export interface BasketSaveForLater {
  currency?: Currency;
  productList?: SaveForLaterBasketItem[];
  full: boolean;
  merged: boolean;
  removedSKUs?: string[];
}

export interface SaveForLaterBasketItem {
  price: number;
  productCode: string;
  productId?: string;
  quantity: number;
  skuId?: string;
  type: string;
  name: string;
  message: string;
  imageUrl: string;
  pdpUrl: string;
  stockLevel: number;
  availabilityStatus: string;
  childItems: BasketItemChildItem[];
  information: BasketItemInformation[];
  variantId: string;
  brand?: Brand;
  preOrder?: PreOrder;
  futureAvailability?: FutureAvailability;
  energy?: BasketItemEnergy;
  sellingRestrictions?: BasketItemSellingRestrictions;
  emailMeWhenAvailable: boolean;
  promotionalMessages: BasketItemPromotionalMessage[];
  originalPrice?: string;
  priceOfferType?: string;
}

export interface BasketItemChildItem {
  currency: string;
  id: string;
  imageUrl: string;
  name: string;
  orderOnSite: number;
  price: number;
  totalPrice: number;
  quantity: number;
  skuId: string;
  variantId: string;
  bundleComponentVariantId?: string;
  discounts: BasketItemDiscount[];
}

export interface BasketItemInformation {
  name: string;
  value: string;
}

export interface PreOrder {
  streetDate: string;
  streetDateMessage: string;
}

export interface FutureAvailability {
  availableToOrderFrom: string;
  availableToOrderFromMessage: string;
}

export interface BasketItemEnergy {
  rating: string;
  imageUrl: string;
  pdfUrl: string;
}

export interface BasketItemSellingRestrictions {
  age: number;
  text: string;
}

export interface BasketItemPromotionalMessage {
  title: string;
  type: string;
  promotionGroup: string;
  promotionType: string;
}

export interface BasketUIBasket {
  orderId?: string;
  subtotal?: number;
  currency?: Currency;
  grandTotal?: number;
  commerceItems?: BasketItem[];
  interestFreeCredit: InterestFreeCredit;
  context?: Context;
  tradeInQuotes: TradeInQuote[];
  offerCode?: string;
  partnerDiscountEnabled?: boolean;
  totalDiscounts: BasketDiscount[];
  totalSavings: number;
}

export interface Brand {
  name: string;
  logo?: string;
}

export interface Context {
  test: boolean;
}

export interface DeliveryMethod {
  id: string;
  cutOffTime: number;
  dateMessage: string;
  leadTime: number;
  shortDescription: string;
  standardDescription: string;
}

export interface DeliveryOption {
  deliveryMethods?: DeliveryMethod[];
  isAvailable: boolean;
  name: string;
  title: string;
}

export interface DeliveryQualificationsResponse {
  basketId: string;
  freeDelivery: FreeDelivery;
  freeClickAndCollect: FreeClickAndCollect;
  moreDeliveryOptions?: MoreDeliveryOptions;
  isTwoPersonDelivery?: boolean;
}

export interface FreeClickAndCollect {
  available: boolean;
  additionalSpendRequired?: number;
  threshold?: number;
  cutOffTime?: string;
  thresholdMessage?: string;
  qualificationMessage?: string;
  cutOffTimeMessage?: string;
}

export interface FreeDelivery {
  available: boolean;
  additionalSpendRequired?: number;
  thresholdMessage?: string;
  qualificationMessage?: string;
}

export interface InterestFreeCredit {
  isApplicable: boolean;
}

export interface LoyaltyError {
  status: number;
  message: string;
}

export interface LoyaltyResponse {
  loyaltyVoucher?: LoyaltyVoucher;
  error?: LoyaltyError;
}

export interface LoyaltyVoucher {
  voucherId: string;
  titleLines: string[];
  endDate: string;
  imageUrl: string;
  selected?: LoyaltyVoucherSelected;
  status?: string;
}

export interface MoreDeliveryOptions {
  available: boolean;
  message: string;
}

export interface Payment {
  value: string;
  displayValue: string;
  type: string;
}

export interface TradeInQuote {
  tradeInQuoteId: string;
  deviceName?: string;
  expiry?: string;
  payment?: Payment;
  errorStatus?: APIErrorCode;
}

export interface OptionalService {
  type: string;
  id: string;
  title: string;
  description?: string;
  price?: number;
  policyDetail?: string;
  tooltip?: string;
  purchaseDescription?: string;
  confirmation?: string;
  dmsId?: string;
  isTopaz: boolean;
}

export interface BasketItemDeliveryOption {
  id: string;
  name: string;
  price: number;
  type: string;
  leadTime: number;
  cutOffTime: number;
  dateMessage: string;
  shortDescription: string;
  standardDescription: string;
}

export interface BasketItemAvailability {
  status: string;
  stockLevel: number;
  isUnlimitedStock: boolean;
}

export interface BasketItemTraits {
  size: string;
  colour: string;
}

export interface BasketItemVariantPrice {
  value: string;
  offerType?: string;
}

export enum Service {
  BASKET,
  CATALOGUE,
  PRICING,
  STOCK,
  FULFILMENT,
  LOYALTY,
  TRADEIN,
  UNKNOWN,
}

export interface SimplifiedBasketItem {
  id: string;
  skuId: string;
  title: string;
  quantity: string;
  price?: number;
  originalPrice?: number;
  variantPrice?: {
    value: number;
  };
  brand?: {
    name: string;
  };
  variantTraits?: {
    colour?: string;
    size?: string;
  };
  detailedPromotionalMessages?: Array<{
    title: string;
    type: string;
    promotionGroup: string;
    promotionType: string;
  }>;
  childItems?: Array<{
    id: string;
    skuId: string;
    name: string;
    price: number;
    quantity: number;
    variantId: string;
  }>;
}

export const ADD_TO_BASKET_CLICK_EVENT_KEY = "add_to_basket_click";
export const EXPRESS_CHECKOUT_CLICK_EVENT_KEY = "express_checkout_click";

// Request types for AddToBasket API
export interface AddToBasketChildItemRequest {
  variantId: string;
  quantity: number;
  bundleComponentVariantId?: string;
}

export interface AddToBasketRequest {
  skuId: string;
  variantId: string;
  quantity: number;
  childItems?: AddToBasketChildItemRequest[];
  express?: boolean;
  isShipFromStore?: boolean;
}

export interface AddToBasketResponse extends BasketRequestResponse {
  success: boolean;
  orderId?: string;
  responseStatus?: number;
  errorMessage?: string;
  commerceItems: BasketItem[];
}
